import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToggleFiltersClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 6.66667V11.6667H3.33333V8.33333H0V6.66667H5ZM8.33333 0V3.33333H11.6667V5H6.66667V0H8.33333Z",
		fill: "#118AB2"
	})
});
export default SvgToggleFiltersClose;
